
<div
  class="info-primaire-promo"
  :class="content.theme"
  :style="{ 'background-color': content.couleur }"
>
  <div class="padding-section mw-100 col-xxl-12" :class="{ 'h-100': !jel_isCarteLarge(content) }">
    <div class="texte-promo">
      <div class="sur-titre-promo" v-html="content.surTitre" />
      <div class="titre-promo" v-html="content.titre" />
      <div v-show="content.texte" class="description-promo" v-html="content.texte" />
    </div>
    <Hyperlien :content="contentBouton"></Hyperlien>
  </div>
</div>
